import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';

export const features = [
    {
        name: 'feature',
        icon: EmailOutlinedIcon,
        title: 'Email Management',
        body: 'Vitae massa euismod enim dictum facilisi aliquam, elit, pretium. Id laoreet suscipit vel sagittis non commodo semper.'
    },
    {
        name: 'feature',
        icon: CalendarTodayOutlinedIcon,
        title: 'Campaign Calender',
        body: 'Vitae massa euismod enim dictum facilisi aliquam, elit, pretium. Id laoreet suscipit vel sagittis non commodo semper.'
    },
    {
        name: 'feature',
        icon: PersonOutlineOutlinedIcon,
        title: 'Personal assistance',
        body: 'Vitae massa euismod enim dictum facilisi aliquam, elit, pretium. Id laoreet suscipit vel sagittis non commodo semper.'
    },
    {
        name: 'feature',
        icon: PaymentOutlinedIcon,
        title: 'Payment Feature',
        body: 'Vitae massa euismod enim dictum facilisi aliquam, elit, pretium. Id laoreet suscipit vel sagittis non commodo semper.'
    },
    {
        name: 'feature',
        icon: GridViewOutlinedIcon,
        title: 'Utility apps',
        body: 'Vitae massa euismod enim dictum facilisi aliquam, elit, pretium. Id laoreet suscipit vel sagittis non commodo semper.'
    },
    {
        name: 'feature',
        icon: NotificationsNoneOutlinedIcon,
        title: 'Sale notification',
        body: 'Vitae massa euismod enim dictum facilisi aliquam, elit, pretium. Id laoreet suscipit vel sagittis non commodo semper.'
    },
]